export default {
  Portrait: "portrait",
  Landscape: "landscape"
};
